import { useTranslation, Trans } from 'react-i18next';
import { Alert } from '@mui/material';
import styled from 'styled-components';
import InfoIcon from '@mui/icons-material/Info';

const StyledAlert = styled(Alert)`
    & .MuiAlert-message {
        font-family: 'Poppins Light', 'Poppins', sans-serif;
        font-size: 14px;
    }
`;

const Green = (
  <strong
    style={{ color: '#0F6B2E' }}
  />
);

export default function TraitsReconciliationInstructions() {
  const { t } = useTranslation();
  return (
    <StyledAlert severity="info" icon={<InfoIcon />} data-testid="traits-reconciliation-instructions">
      {t('Traits.Instructions.General')}
      <p>
        <Trans i18nKey="Traits.Instructions.Updates" components={{ Green }} />
      </p>
      <Trans i18nKey="Traits.Instructions.Deletes" />
    </StyledAlert>
  );
}
